import { useMutation, useQuery } from "@apollo/client";
import {
  chargeWalletMutation,
  WalletGatewaysList,
} from "../../../graphql/none_saleor/wallet/wallet";
import { Button, Radio, Spin } from "antd";
import { Box, Note, Uniter } from "../../../helbest";
import { useState } from "react";
import styles from "./Wallet.module.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const AddWallet = () => {
  const { t } = useTranslation();

  const [gate, setGate] = useState();
  const [amount, setAmount] = useState("");
  const { channel } = useSelector((state) => state.Login);

  const onChange = (e) => {
    setGate(e.target.value);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue)) {
      setAmount(inputValue);
    }
  };

  const { data: gateways, loading } = useQuery(WalletGatewaysList, {
    context: {
      // headers: {
      //   "site-url": "garajmall.com",
      // },
      clientName: "wallet",
    },
    onError: (err) => {
      Note.error(err.message);
    },
    variables: {
      channel,
    },
  });

  const [chargeWallet, { loading: chargeLoading }] = useMutation(
    chargeWalletMutation,
    {
      context: {
        // headers: {
        //   "site-url": "garajmall.com",
        // },
        clientName: "wallet",
      },
      variables: {
        channel,
      },
    }
  );

  const submitCharge = () => {
    chargeWallet({
      variables: {
        gatewayId: gate,
        amount: amount,
        callbackHost: window.location.origin,
      },
      onCompleted: (response) => {
        if (response.chargeWallet.result.success) {
          window.location.href = response.chargeWallet.result.url;
        } else {
          Note.error(response.chargeWallet.result.message);
        }
      },
    });
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spin size="default" />
      </div>
    );
  }

  return (
    <Box className="p-4 h-full">
      <div className={styles.InputContainer}>
        <span className={styles.InputTitle}>{t("wallet.charge")}</span>
        <input
          className={styles.Input}
          placeholder={t("wallet.placeholder")}
          pattern="[0-9]*"
          inputMode="numeric"
          onChange={handleInputChange}
          value={amount}
        />
        <div className={styles.Buttons}>
          {suggestions.map((suggest) => (
            <div
              key={suggest}
              className={styles.Button}
              onClick={() => setAmount(suggest)}
            >
              <Uniter childSize={16} unitSize={12} unit="OMR" isBold>
                {suggest}
              </Uniter>
            </div>
          ))}
        </div>
      </div>
      <Radio.Group
        onChange={onChange}
        value={gate}
        className={`${styles.paymentRadio} mt-10`}
      >
        {gateways?.chargeWalletAvailableGateways.map((gate) => (
          <Radio
            value={gate?.id}
            defaultChecked
            key={gate.id}
            style={{
              margin: 0,
            }}
          >
            <div className="flex items-center gap-2">
              <img alt="gateIcons" src={gate.logo} width={36} height={36} />{" "}
              <span>{gate.name}</span>
            </div>
          </Radio>
        ))}
      </Radio.Group>
      <div className="page-fixed-footer-container">
        <Button
          type="primary"
          size="large"
          style={{
            width: "100%",
            maxWidth: "276px",
          }}
          onClick={submitCharge}
          loading={chargeLoading}
          disabled={!gate || !amount}
        >
          {t("common.confirm")}
        </Button>
      </div>
    </Box>
  );
};

export default AddWallet;

const suggestions = [10, 20, 50];
